const AUTHENTICATION = "AUTHENTICATION";
const AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR";
const LOGOUT = "LOGOUT";

export { AUTHENTICATION, AUTHENTICATION_ERROR, LOGOUT };